import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

// Creates a <style> tag in the head of the document and populates it
// with the CSS provided via children
export class Style extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,

    // This is a workaround until I can figure out the right way of doing it
    // eslint-disable-next-line react/forbid-prop-types
    targetDocument: PropTypes.any,
  };

  static defaultProps = {
    targetDocument: document,
  };

  constructor(props) {
    super(props);

    const { targetDocument } = props;

    this.element = targetDocument.createElement('style');
    targetDocument.head.appendChild(this.element);
  }

  componentWillUnmount() {
    this.element.remove();
    this.element = null;
  }

  render() {
    const { children } = this.props;

    return ReactDOM.createPortal(children, this.element);
  }
}
